export const CONTACT_US_URL =
  'https://www.storebrand.no/infosider/kontakt-oss/privat';
